import React from "react";
import { toElement } from "../../utils/utils";

function Policy({ text }) {
  return <div className="policy-container body-b1">{toElement(text)}</div>;
}

export default Policy;
